import { CompanyDetailAndJobGroups } from '@types';
import { useSidebarItems } from './sidebar-items';

export const filterOutSidebarItems = (
  sidebarItems: ReturnType<typeof useSidebarItems>,
  company: CompanyDetailAndJobGroups | undefined
) => {
  // creates shallow copy of sidebar items to avoid mutating the original array
  const result = sidebarItems.map((section) => ({
    ...section,
    children: [...section.children],
  }));

  if (!company?.company.offersEmployeeWork) {
    const planningSection = result.find((s) => s.key === 'planning');
    if (planningSection) {
      planningSection.children = planningSection.children.filter(
        (item) => item.path !== 'management/workforce'
      );
    }
  }

  return result;
};
